module.exports = __webpack_public_path__ + "img/logo-sm.3c8837be.png";